import { connect } from 'react-redux'
import List from '../../Main/Profile/_List'
import { selectMedal } from '../../../actions'
import image_url from './title.png'

const mapStateToProps = state => ({
  list_name: 'Nuevos Títulos',
  empty_message: '¡Esta misión no dió titulos!',
  items: state.missions.answerMission.progress.earned_for_winning.new_titles.map(x =>
    ({ ...x, text: x.prefix_male, image_url }),
  ),
})

const mapDispatchToProps = dispatch => ({
  toggleDialog: (id, toggleOpen) => {
    dispatch(selectMedal({ id }))
    toggleOpen()
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/NewTitles/index.jsx